import { useQuery } from 'react-query';
import { AuthenticatedUser } from '../../../../../../../shared/types';
import { useTelemetryContext } from '../../../../../../../telemetry/telemetryContext';
import ImageProcessingApi from '../../../api/ImageProcessingApi';
import { getUserInfo } from '../../../../../../../telemetry/utils';

export type ImageProcessingComments = {
    fromEditorComment: string | null;
    fromPhotographerToEditorComment: string | null;
    toEditorFromChainComment: string | null;
    toEditorFromFirmComment: string | null;
    editingStyle: string | null;
};

type ImageProcessingCommentsQueryArgs = {
    orderId: number;
    user: AuthenticatedUser;
};

export let imageProcessingCommentsQueryKey = 'image-editor-image-processing-comments';

export function useImageProcessingCommentsQuery({ orderId, user }: ImageProcessingCommentsQueryArgs) {
    let { logger } = useTelemetryContext();

    let { data, isLoading } = useQuery<ImageProcessingComments>(
        [imageProcessingCommentsQueryKey, { orderId }],
        () => ImageProcessingApi.getImageProcessingInfo(orderId),
        {
            useErrorBoundary: true,
            onError: (error) => {
                let additionalInfo = {
                    origin: 'ImageEditorImageProcessingPage.Query.getImageProcessingInfo',
                    userInfo: getUserInfo(user)
                };
                logger.logException(error, additionalInfo);
            }
        }
    );

    return { data: data != null ? data : null, isLoading };
}
